export const DEFAULT_VALID_QUERY_LENGTH = 1;
